module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/ally-barker-ffe8a2f5972530e265375f19e45826c6.jpg";